@if (
  {
    expanded: (facettenService.expanded$ | async)!,
    selectedFilterCount: (selectedFilterCount$ | async)!
  };
  as context
) {
  <ng-template #contentTemplate>
    <ng-content></ng-content>

    <div class="d-flex justify-content-center mt-2">
      <button
        class="now-btn now-btn-tertiary text-nowrap"
        (click)="facettenService.reset()"
        type="button"
        [disabled]="context.selectedFilterCount === 0"
        [id]="'reset-facette-' + id"
      >
        Zurücksetzen
      </button>
    </div>
  </ng-template>

  @if (isDesktop$ | async) {
    <div #dropdown class="dropdown now-filter-dropdown">
      <button
        class="now-filter-dropdown-button"
        [id]="'toggle_facette_' + id"
        #toggle
        [ngClass]="{
          active: context.selectedFilterCount > 0,
          'facette-loading': isLoading
        }"
        aria-expanded="false"
        type="button"
        [disabled]="isLoading"
      >
        <span>{{ label }}</span>
        @if (context.selectedFilterCount > 0) {
          <span class="now-badge" aria-hidden="true" [id]="'count_' + id">{{
            context.selectedFilterCount
          }}</span>
        }
        @if (context.selectedFilterCount > 0) {
          <span class="sr-only">{{ context.selectedFilterCount }} ausgewählter Filter</span>
        }
        <span class="now-icon"></span>
      </button>
      <div class="dropdown-menu dropdown-menu-start now-dropdown-content" #facetteContainer>
        @if (context.expanded === true) {
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        }
      </div>
    </div>
  }

  @if ((isDesktop$ | async) === false) {
    <div class="now-accordion-item" #mobileAccordionItem>
      <button
        type="button"
        class="now-accordion-button collapsed"
        [ngClass]="{ 'now-checked': context.selectedFilterCount }"
        [attr.aria-controls]="'accordion-body--' + id"
        data-bs-toggle="collapse"
        aria-expanded="false"
        [attr.data-bs-target]="'#accordion-body--' + id"
        (click)="toggleExpansion()"
      >
        <span class="now-accordion-btn-label">{{ label }}</span>
        @if (context.selectedFilterCount) {
          <span class="now-badge" aria-hidden="true" [id]="'count_' + id">{{
            context.selectedFilterCount
          }}</span>
        }
        @if (context.selectedFilterCount) {
          <span class="sr-only">{{ context.selectedFilterCount }}</span>
        }
      </button>
      <div [attr.id]="'accordion-body--' + id" class="collapse">
        <div class="now-accordion-panel">
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
      </div>
    </div>
  }
}
